import React from 'react';
import { trustItems } from '../data/trust';
export function TrustBar() {
  return <section aria-label="Razones para confiar" className="border-b border-hairline bg-white py-9 lg:py-12" data-id="element-323" data-mp="1bzvrohdrz8m4">
      <div className="mx-auto max-w-shell px-5 lg:px-[120px]" data-id="element-324" data-mp="y991xepzst26">
        <ul className="grid grid-cols-2 gap-x-6 gap-y-8 lg:grid-cols-4 lg:gap-0" data-id="element-325" data-mp="y6mnqw8ljfaz">
          {trustItems.map((item, index) => {
          const Icon = item.icon;
          return <li key={item.id} className={`lg:px-8 ${index > 0 ? 'lg:border-l lg:border-hairline' : 'lg:pl-0'}`} data-id="element-326" data-mp="1qy6cevnyplkd" data-mpi={index}>
                <Icon className="h-8 w-8 text-secondary" strokeWidth={1.5} data-id="element-327" data-mp="1gy5murzi297q" />
                <h3 className="mt-4 font-sans text-[16px] font-semibold text-ink" data-id="element-328" data-mp="1lxsbryooxdwd">{item.title}</h3>
                <p className="mt-2 font-sans text-[14px] leading-[1.6] text-muted" data-id="element-329" data-mp="5jin13gjdn50">{item.description}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}